import React from 'react';
import SecFilingPriorityPill from './SecFilingPriorityPill';
import SecFilingTypePill from './SecFilingTypePill';

const formatValue = (value) => (value ? value : '—');

export default function SecFilingDetailSections({ filing }) {
  if (!filing) return null;

  return (
    <>
      <div className="detail-section">
        <div className="ds-title">Filing info</div>
        <div className="field-grid">
          <div className="field field--span-full">
            <div className="field-label">Filing description</div>
            <div className="field-val">{formatValue(filing.filingDescriptionDisplay)}</div>
          </div>
          <div className="field">
            <div className="field-label">Filing type</div>
            <div className="field-val sec-filing-table-drawer__filing-type">
              <SecFilingTypePill filingType={filing.filingType} />
            </div>
          </div>
          <div className="field">
            <div className="field-label">Priority</div>
            <div className="field-val">
              <SecFilingPriorityPill isCritical={filing.isCritical} />
            </div>
          </div>
        </div>
      </div>

      <div className="detail-section">
        <div className="ds-title">Company details</div>
        <div className="field-grid">
          <div className="field">
            <div className="field-label">Company</div>
            <div className="field-val">{formatValue(filing.company)}</div>
          </div>
          <div className="field field--span-full">
            <div className="field-label">Entity</div>
            <div className="field-val sec-filing-table-drawer__entity-header">
              {formatValue(filing.entityHeaderDisplay || filing.entity)}
            </div>
          </div>
          <div className="field">
            <div className="field-label">CIK</div>
            <div className="field-val">{formatValue(filing.displayCik || filing.cik)}</div>
          </div>
          <div className="field">
            <div className="field-label">SIC Code</div>
            <div className="field-val">{filing.sicCodeDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Ticker Symbol</div>
            <div className="field-val">{filing.tickerDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Exchange</div>
            <div className="field-val">{filing.exchangeDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Filer Category</div>
            <div className="field-val">{filing.filerCategoryDisplay}</div>
          </div>
        </div>
      </div>

      <div className="detail-section">
        <div className="ds-title">Key dates</div>
        <div className="field-grid">
          <div className="field">
            <div className="field-label">Accepted</div>
            <div className="field-val">{filing.acceptedAtDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Filing date</div>
            <div className="field-val">{filing.filedDateDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Period of report</div>
            <div className="field-val">{filing.periodOfReportDisplay}</div>
          </div>
        </div>
      </div>

      <div className="detail-section">
        <div className="ds-title">EDGAR filing metadata</div>
        <div className="field-grid">
          <div className="field field--span-full">
            <div className="field-label">Accession number</div>
            <div className="field-val sec-filing-table-drawer__accession">
              {formatValue(filing.accessionNumber)}
            </div>
          </div>
          <div className="field">
            <div className="field-label">File number</div>
            <div className="field-val">{filing.fileNumberDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Film number</div>
            <div className="field-val">{filing.filmNumberDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Act</div>
            <div className="field-val">{filing.actDisplay}</div>
          </div>
          <div className="field">
            <div className="field-label">Size</div>
            <div className="field-val">{filing.sizeDisplay}</div>
          </div>
        </div>
      </div>
    </>
  );
}
